export const content = [
    {
        id: 1,
        text: '<h4>Your device, delivered straight to your door.</h4>'
    },
    {
        id: 2,
        text: '<p>How it works:</p>' +
        '<ul>' +
        '<li>Enjoy free delivery within 3-5 working days after your order is confirmed (unless its a pre-order).</li>' +
        '<li>Your subscription only starts once the device has been delivered.</li>' +
        '<li>While we take the first month’s payment upfront, your billing begins upon receipt of the device.</li>' +
        '</ul>'
    },
    {
        id: 3,
        text: '<p>Limitations:</p>' +
        '<ul>' +
        '<li>Pre-ordered devices may take a bit longer depending on device release cycles.</li>' +
        '<li>In rare cases where we can’t meet the 3-5 day guarantee, we’ll reach out to arrange a suitable delivery time.</li>' +
        '</ul>'
    }
];

export const preOrderContent = [
    {
        id: 1,
        text: '<h4>Your device, delivered straight to your door.</h4>'
    },
    {
        id: 2,
        text: '<p>How it works:</p>' +
        '<ul>' +
        '<li>Enjoy free delivery before the specified date after your order is confirmed.</li>' +
        '<li>Your subscription only starts once you have the device in your hands.</li>' +
        '<li>While we take the first month’s deposit upfront, your billing begins upon receipt of the device.</li>' +
        '</ul>'
    },
    {
        id: 3,
        text: '<p>Limitations:</p>' +
        '<ul>' +
        '<li>Pre-ordered devices take a bit longer to deliver due to the device not being released by the manufacturer.</li>' +
        '<li>In rare cases where there are unforeseen delays, we’ll reach out to arrange a suitable delivery time.</li>' +
        '</ul>'
    }
];

export const s25Content = [
    {
        id: 1,
        text: '<h4>Your device, delivered straight to your door.</h4>'
    },
    {
        id: 2,
        text: '<p>How it works:</p>' +
        '<ul>' +
        '<li>Enjoy free delivery, starting from 14 February.</li>' +
        '<li>Your subscription only starts once the device has been delivered.</li>' +
        '<li>While we take the first month’s payment upfront, your billing begins upon receipt of the device.</li>' +
        '</ul>'
    },
    {
        id: 3,
        text: '<p>Limitations:</p>' +
        '<ul>' +
        '<li>Pre-ordered devices may take a bit longer depending on device release cycles.</li>' +
        '<li>In rare cases where we can’t meet the 3-5 day guarantee, we’ll reach out to arrange a suitable delivery time.</li>' +
        '</ul>'
    }
];
